import React from 'react';
import moment from 'moment';

import styles from './styles.module.scss';

const ACTIVITY_DOT_COLORS = {
  created: '#0085ff',
  published: '#0085ff',
  version_published: '#0085ff',
};

const Activities = ({ activities = [] }) => (
  <div className={styles.timeline}>
    {activities.map((activity) => {
      const occurredAt = moment(activity.occurred_at);
      const dateLabel = occurredAt.isValid() ? occurredAt.format('MMM D, HH:mm') : '';

      return (
        <div key={activity.id} className={styles.activity}>
          <span
            className={styles.dot}
            style={{ backgroundColor: ACTIVITY_DOT_COLORS[activity.type] || '#bfc3c7' }}
          />
          <div className={styles.info}>
            <div className={styles.title}>{activity.title}</div>
            <div className={styles.date}>
              {dateLabel}
              {dateLabel && activity.actor?.name ? ' · ' : ''}
              {activity.actor?.name}
            </div>
          </div>
        </div>
      );
    })}
  </div>
);

export default Activities;
